import React, { useContext, useState } from 'react';
import { Card } from 'components/card';
import { Button, ButtonsGroup } from 'components/button';
import { getTestSessionURL } from 'utils/url';
import { openNewWindow } from 'utils/browser';
import Icon from 'components/icon/Icon';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'messages';
import { MenuWrapper } from 'components/menu';
import { useSessionContext } from 'contexts/SessionContext';
import { StoreContext } from 'index';
import CopyUrlModal from 'containers/partials/modals/CopyUrlModal';
import { PackageTypes } from 'constants';

const SessionLinks = ({ entityId }) => {
  const { session } = useSessionContext();
  const [copyUrlModal, setCopyUrlModal] = useState(false);

  if (session.personEntities.length !== 0) {
    return (
      <>
        <Card
          secondary
          multiBody
          extraClassNames="o-flex o-flex--justify-center o-flex--algin-center"
          style={{ minHeight: 128 }}
        >
          <ButtonsGroup
            extraClassNames="o-flex--column o-flex--justify-center u-padding-bottom-none"
            style={{ maxWidth: 'calc(100% - 32px)', gap: 12 }}
          >
            {(session.isILike || session.isIDoILike) && (
              <SessionLinkButton
                entityId={entityId}
                setCopyUrlModal={setCopyUrlModal}
                type={PackageTypes.ILIKE}
              />
            )}
            {(!session.isILike || session.isIDoILike) && (
              <SessionLinkButton
                entityId={entityId}
                setCopyUrlModal={setCopyUrlModal}
                type={session?.config?.type}
              />
            )}
          </ButtonsGroup>
        </Card>
        {copyUrlModal && (
          <CopyUrlModal
            isOpen={true}
            content={`${copyUrlModal}`}
            onClose={() => setCopyUrlModal(false)}
          />
        )}
      </>
    );
  }
};

export default SessionLinks;

const SessionLinkButton = ({ entityId, type, setCopyUrlModal }) => {
  const {
    authStore: { user },
    uiState: { locale }
  } = useContext(StoreContext);
  const { session } = useSessionContext();
  const intl = useIntl();

  const sessionUrl = session?.id // && session?.config?.type
    ? getTestSessionURL({
        entityId,
        sessionId: session.id,
        packageType: type ?? 'talent',
        locale,
        personId: null,
        session,
        copyAble: true
      })
    : '';

  return (
    <ButtonsGroup
      halfButtons
      extraClassNames="o-flex--justify-center u-margin-auto"
      style={{ gap: 0 }}
    >
      <Button
        halfRounded
        primary
        extraClassNames="c-button--double-button-shrink"
        title={intl.formatMessage(
          messages[`buttonShortName_${type}`] ?? messages[`buttonShortName`]
        )}
        data-label={intl.formatMessage(
          messages[`buttonShortName_${type}`] ?? messages[`buttonShortName`]
        )}
        onClick={() => {
          const url = getTestSessionURL({
            entityId,
            sessionId: session.id,
            packageType: type ?? 'talent',
            locale: user.baseLanguage
          });
          openNewWindow(url);
        }}
      >
        <Icon id="test-white" />
        {session.isNotStarted ? (
          <FormattedMessage
            {...(messages?.[`buttonSessionStartSession_${type}`] ??
              messages?.[`buttonSessionStartSession`])}
          />
        ) : (
          <FormattedMessage
            {...(messages?.[`buttonSessionContinueSession_${type}`] ??
              messages?.[`buttonSessionContinueSession`])}
          />
        )}
      </Button>
      <MenuWrapper
        trigger={
          <Button halfRounded primary>
            <Icon id="dropdown-open" fillColor="color-neutral" />
          </Button>
        }
      >
        <Button
          menu
          onClick={() => {
            const url = getTestSessionURL({
              entityId,
              sessionId: session.id,
              packageType: type ?? 'talent',
              locale
            });
            openNewWindow(url);
          }}
        >
          <FormattedMessage {...messages.menuItemSessionOpenTestApp} />
          <Icon id="test-gray" />
        </Button>
        <Button menu onClick={() => setCopyUrlModal(sessionUrl)}>
          <FormattedMessage {...messages.menuItemSessionCopyUrl} />
          <Icon id="link" />
        </Button>
      </MenuWrapper>
    </ButtonsGroup>
  );
};
